import { sendGtmEvent } from './gtm'

export const ButtonElement = {
  ActivateInApp: 'ActivateInApp',
  DownloadAppAndroid: 'DownloadAppAndroid',
  DownloadAppApple: 'DownloadAppApple',
  GetPromocode: 'GetPromocode',
  OpenInstruction: 'OpenInstruction',
  SeeInstruction: 'SeeInstruction',
} as const

export type ButtonElement = (typeof ButtonElement)[keyof typeof ButtonElement]

export const ButtonLocation = {
  Advantages: 'Advantages',
  EasySending: 'EasySending',
  Footer: 'Footer',
  GetPromoWindow: 'GetPromoWindow',
  Header: 'Header',
  Hero: 'Hero',
  HowDoesItWork: 'HowDoesItWork',
  Instruction: 'Instruction',
  PromoGranted: 'PromoGranted',
  Promo: 'Promo',
} as const

export type ButtonLocation = (typeof ButtonLocation)[keyof typeof ButtonLocation]

export const FormElement = {
  GetPromo: 'GetPromo',
} as const

export type FormElement = (typeof FormElement)[keyof typeof FormElement]

export const trackButtonClick = (element: ButtonElement, location: ButtonLocation) => {
  sendGtmEvent({ event: 'ButtonClick', Param1: element, Param2: location })
}

export const trackFormSent = (element: FormElement) => {
  sendGtmEvent({ event: 'FormSent', Param1: element })
}
